import { DEFAULT_UNIFIED_SETTINGS } from "@cmmd-forge/contracts/settings";

import { useSettings, useUpdateSettings } from "../../hooks/useSettings";
import { Switch } from "../ui/switch";
import {
  SettingResetButton,
  SettingsPageContainer,
  SettingsRow,
  SettingsSection,
} from "./settingsLayout";
import { searchableSetting } from "./settingsSearch";

export function ComposerSettingsPanel() {
  return (
    <SettingsPageContainer>
      <ComposerSettingsSection />
    </SettingsPageContainer>
  );
}

export function ComposerSettingsSection() {
  const settings = useSettings();
  const { updateSettings } = useUpdateSettings();
  const isDirty =
    settings.showInteractionModeToggle !== DEFAULT_UNIFIED_SETTINGS.showInteractionModeToggle;

  return (
    <SettingsSection id="composer" title="Composer">
      <SettingsRow
        {...searchableSetting("composer-build-plan-toggle")}
        description="Show the Build/Plan mode button in the composer footer."
        resetAction={
          isDirty ? (
            <SettingResetButton
              label="Build/Plan mode toggle"
              onClick={() =>
                updateSettings({
                  showInteractionModeToggle: DEFAULT_UNIFIED_SETTINGS.showInteractionModeToggle,
                })
              }
            />
          ) : null
        }
        control={
          <Switch
            checked={settings.showInteractionModeToggle}
            onCheckedChange={(checked) =>
              updateSettings({ showInteractionModeToggle: Boolean(checked) })
            }
            aria-label="Show Build/Plan mode toggle in composer"
          />
        }
      />
    </SettingsSection>
  );
}
